<div class="row">
  <div class="col-md-12">
    <div class="alert alert-info" *ngIf="templateConfirmacaoPresenca">
      Este é o template padrão da confirmação de presença. Os parâmetros de Cabeçalho e Corpo precisam possuir uma origem de preenchimento automático.
      <div *ngIf="getParametrosOrigemPendente().length > 0">
        <strong>Parâmetros pendentes:</strong> {{getParametrosOrigemPendente().join(', ')}}
      </div>
    </div>
    <button mat-flat-button color="primary" type="button" (click)="create()">Adicionar Item</button>
  </div>
  <hr />
  <div class="col-md-12">
    <table datatable [dtOptions]="dtOptions" *ngIf="dtOptions" class="table table-bordered table-striped table-hover"
      style="width: 100%;">
      <thead>
        <tr>
          <th class="text-center" width="80">Ordem</th>
          <th class="text-center" width="160">Tipo</th>
          <th class="text-center" width="120">Formato</th>
          <th class="text-center">Texto</th>
          <th class="text-center">Exemplo JSON</th>
          <th class="text-center" width="150"></th>
        </tr>
      </thead>
      <tbody *ngIf="models?.length != 0">
        <tr *ngFor="let item of models">
          <td class="text-center">{{item.order}}</td>
          <td>{{typesService.getMetaMsgTemplateComponentTypeNome(item.tipo)}}</td>
          <td>{{typesService.getMetaMsgTemplateComponentFormatTypeNome(item.format)}}</td>
          <td>{{item.text}}</td>
          <td>{{item.exampleJson}}</td>
          <td class="text-center">
            <button mat-icon-button type="button" (click)="edit(item)" matTooltip="Editar">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button type="button" (click)="delete(item.id)" matTooltip="Excluir">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <app-meta-msg-template-component-modal #modal (modalSave)="onResponse($event)"
    [metaMsgTemplateId]="metaMsgTemplateId" [templateConfirmacaoPresenca]="templateConfirmacaoPresenca">
  </app-meta-msg-template-component-modal>
</div>
